import React, { ReactNode } from 'react';
import { Hyperlink } from '../../../atoms/Hyperlink';

type LinkedImage = {
  linkUrl?: string;
  hideAdjacentImageLink?: boolean;
  children: ReactNode;
};

/**
 * Sometimes we have to directly wrap the image in a link, e.g. for images in teaser lists.
 * When the component consists of a second link with same address, this images-link is redundant.
 * That's why we make it not tabbable, and it's made aria-hidden="true" on the outside component.
 */
export function LinkedImage({ linkUrl, hideAdjacentImageLink, children }: LinkedImage) {
  if (linkUrl) {
    return (
      <Hyperlink className="image__link" to={linkUrl} tabIndex={hideAdjacentImageLink ? -1 : undefined}>
        {children}
      </Hyperlink>
    );
  }

  return children;
}
